module.exports = __webpack_public_path__ + "static/media/regedit_101.863d4a89.ico";